<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <p class="text-sm ml-5 font-semibold py-4 w-full">List of Job Titles</p>
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>

        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-1 rounded-md"
        />
        <!-- search -->

        <div class="flex flex-wrap justify-end w-full gap-3 pr-3">
          <button
            @click="showCreateJobTitle = true"
            class="bg-primary text-white rounded-full px-2 text-sm flex gap-1 align-middle items-center"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>

          <button
            @click="showBulkUploadForm"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Import
          </button>
          <button
            @click="exportTemplate"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Export
          </button>
        </div>
      </div>
      <div class="px-2 pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
          sort-order="asc"
        />

        <ve-table
          :columns="columns"
          :tableData="currentTableData"
          v-if="!searchInput.length"
        >
        </ve-table>
        <p
          v-if="searchInput.length && filteredTableData.length === 0"
          class="text-center py-3"
        >
          No results
        </p>
        <p
          v-if="tableData.length == 0 && !loading && !get_error"
          class="p-1 text-center text-sm w-full bg-gray-100"
        >
          No Job Titles found
        </p>
        <!-- Pagination -->
        <div class="table-pagination text-center mt-2">
          <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          >
            <!-- :current-page.sync="currentPage4" -->
          </el-pagination>
        </div>
        <!-- Pagination -->
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateJobTitle
      @close="handleClose"
      :showCreateJobTitle="showCreateJobTitle"
      @closeOnSuccess="handleCloseOnSuccess"
      :existingJobTitles="tableData"
    >
    </CreateJobTitle>
    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
    <EditJobTitle
      :showEditJobTitle="showEditJobTitle"
      :jobTitleToEdit="jobTitleToEdit"
      @close="showEditJobTitle = false"
      :reload="reload"
      :existingJobTitles="tableData"

    >
    </EditJobTitle>
    <BulkUploadAssets
      :show-asset-bulk-upload="showAssetBulkUpload"
      v-if="showAssetBulkUpload"
      @close="showAssetBulkUpload = false"
      :reload="reload"
    ></BulkUploadAssets>
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="JobTitles"
      :url="url"
      :dateColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
  </div>
</template>

<script>
import BulkUploadAssets from "@/components/employees/modals/bulkUploadAssets.vue";
import axios from "axios";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import CreateJobTitle from "@/components/CompanySetups/jobTitles/create.vue";
import EditJobTitle from "@/components/CompanySetups/jobTitles/editJobTitle.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
//import { utils, writeFileXLSX } from "xlsx";
export default {
  name: "JobTitlesList",
  components: {
    Loader,
    CreateJobTitle,
    ActionWarning,
    EditJobTitle,
    BulkUploadAssets,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
  },
  data() {
    return {
      url: "",
      resultColumns: [],
      showBulkUpload: false,
      showAssetBulkUpload: false,
      showCreateJobTitle: false,
      loading: false,
      get_error: null,
      create_success: "Job Title created successfully",
      del_loca: "Job Title deleted successfully",
      del_error: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      message: null,
      title: "Job Titles",
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      filteredTabs: [],

      showWarning: false,
      showEditJobTitle: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "name",
          title: "Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Application Developer",
        },
        {
          field: "Hierarchy",
          key: "hierarchy",
          title: "Hierarchy",
          headerAlign: "left",
          align: "left",
          sampleValue: "0",
        },
        {
          field: "Description",
          key: "description",
          title: "Description",
          headerAlign: "left",
          align: "left",
          sampleValue: "Writing Source Code",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0, 10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>

                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  created() {
    this.getJobTitles();
    this.setPageSizes();
    this.filteredTabs = this.columns.filter(
      (column) => column.title !== "Action" && column.title !== "#"
    );
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  methods: {
    reload() {
      this.showEditJobTitle = false;
      this.getJobTitles();
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.url = `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/import`;
      this.showBulkUpload = true;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getJobTitles();
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateJobTitle = false;
    },
    handleCloseOnSuccess() {
      this.showCreateJobTitle = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getJobTitles();
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getJobTitles();
    },
    //  /{organization}/setup/jobtitle/v1/request
    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              console.log(response.data.Data)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/jobtitle/v1/delete
    deleteJobTitle(row) {
      this.loading = true;
      axios
        .delete(`${this.getOrganization}/setup/jobtitle/v1/delete`, {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
          data: {
            JobTitleId: row.Id,
          },
        })
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },

    setIsConfirmed() {
      this.showWarning = false;
      if (this.jobTitleToDelete) {
        this.deleteJobTitle(this.jobTitleToDelete);
        return;
      }
    },

    changePage(page) {
      this.currentPage = page;
    },

    handleEditButtonClick(jobTitle) {
      // Handle the button click for the edit button
      //console.log(jobTitle);
      this.jobTitleToEdit = {
        JobTitleId: jobTitle.Id,
        Name: jobTitle.Name,
        Description: jobTitle.Description,
        ReportsTo:jobTitle.ReportsToId
      };

      //console.log(this.jobTitleToEdit)
      this.showEditJobTitle = true;
    },
    handleDeleteButtonClick(jobTitle) {
      // Handle the button click for the delete button
      //console.log(jobTitle)
      this.title = `Delete ${jobTitle.Name}`;
      this.message = `You are about to delete ${jobTitle.Name}!`;
      this.jobTitleToDelete = jobTitle;
      //console.log(this.jobTitleToDelete)
      this.showWarning = true;
    },

    // ACTION

    exportTemplate() {
      importTemplateGenerator(this.filteredTabs, "Job Titles");
    },
  },
};
</script>
